__turbopack_context__.v({
  "boldText": "vaanWq_boldText",
});
